import toast from 'react-hot-toast'
import api from './api'
import { fallback, paginate, getUserApplications } from './fallbackData'

export const applicationService = {
  async getAllApplications(params) {
    try {
      const response = await api.post('/applications/get-all-applications', params)
      const { items, pagination } = paginate(response?.data, params.page || 1, params.limit || 10)
      // return { applications: items, pagination }
      return { response, pagination } // { applications, pagination }
    } catch (e) {
      // const { items, pagination } = paginate(fallback.applications, params.page || 1, params.limit || 10)
      // return { applications: items, pagination }
      toast.error(e.response.data.message || 'failed to fetch data')
    }
  },

  async getEducatorAllApplications(params) {
    try {
      const response = await api.post('/applications/get-educator-applications', params)
      const { items, pagination } = paginate(response?.data, params.page || 1, params.limit || 10)
      return { response, pagination } // { applications, pagination }
    } catch (e) {
      // const { items, pagination } = paginate(fallback.applications, params.page || 1, params.limit || 10)
      // return { applications: items, pagination }
      toast.error(e.response.data.message || 'failed to fetch data')
    }
  },
  async getStudentAllApplications(params) {
    try {
      const response = await api.post('/applications/get-student-applications', params)
      return response // { applications, pagination }
    } catch (e) {
      // const { items, pagination } = paginate(fallback.applications, params.page || 1, params.limit || 10)
      // return { applications: items, pagination }
      toast.error(e.response.data.message || 'failed to fetch data')
    }
  },
  async getFamilyAllApplications(params) {
    try {
      const response = await api.post('/applications/get-family-applications', params)
      return response // { applications, pagination }
    } catch (e) {
      // const { items, pagination } = paginate(fallback.applications, params.page || 1, params.limit || 10)
      // return { applications: items, pagination }
      toast.error(e.response.data.message || 'failed to fetch data')
    }
  },

  async getApplicationById(id) {
    try {
      const response = await api.post(`/applications/get-admin-applications-detail`,id)
      return response
    } catch (e) {
      toast.error(e.response.data.message || 'failed to fetch data')
    }
  },

  
  async getStudentApplicationDetailById(id) {
    try {
      const response = await api.post(`/applications/get-student-applications-detail`,id)
      return response
    } catch (e) {
      toast.error(e.response.data.message || 'failed to fetch data')
    }
  },
  async getFamilyApplicationDetailById(id) {
    try {
      const response = await api.post(`/applications/get-family-applications-detail`,id)
      return response
    } catch (e) {
      toast.error(e.response.data.message || 'failed to fetch data')
    }
  },

  async createApplication(applicationData) {
    try {
      const response = await api.post('/applications/add-applications', applicationData)
      return response
    } catch (e) {
      toast.error(e.response.data.message || 'failed to create application')
    }
  },

  async updateApplication(id, applicationData) {
    try {
      const response = await api.put(`/applications/${id}`, applicationData)
      return response.data
    } catch (e) {
      const existing = fallback.applications.find(a => a.id === Number(id)) || {}
      return { ...existing, ...applicationData }
    }
  },

  async deleteApplication(id) {
    try {
      const response = await api.post(`/applications/delete-application`, id)
      return response
    } catch (e) {
      toast.error(e.response.data.message || 'failed to delete application')
    }
  },

  async assignApplicationToUser(assignmentData) {
    try {
      const response = await api.post('/applications/assign', assignmentData)
      return response.data
    } catch (e) {
      return { ...assignmentData, id: Date.now() }
    }
  },

  async getUserApplications(userId) {
    try {
      const endpoint = userId ? `/applications/user/${userId}` : '/applications/user'
      const response = await api.get(endpoint)
      return response.data
    } catch (e) {
      const uid = userId || fallback.demoUser.id
      const apps = getUserApplications(uid)
      return apps
    }
  },

  async getAllSubject() {
    try {
      const response = await api.post('/applications/get-subjects')
      return response
    } catch (e) {
      toast.error(e.response.data.message || 'failed to fetch data')
    }
  },

  async getAllGrades() {
    try {
      const response = await api.post('/applications/get-grades')
      return response
    } catch (e) {
      toast.error(e.response.data.message || 'failed to fetch data')
    }
  },
  async getAllEductorList() {
    try {
      const response = await api.post('/applications/get-educator')
      return response
    } catch (e) {
      throw e
    }
  },
  async getAllApplicationForFilter() {
    try {
      const response = await api.post('/applications/get-all-applications-for-filter')
      return response
    } catch (e) {
      toast.error(e.response.data.message || 'failed to fetch data')
    }
  },
  async getAllApplicationStatusForFilter() {
    try {
      const response = await api.post('/applications/get-all-status-for-filter')
      return response
    } catch (e) {
      toast.error(e.response.data.message || 'failed to fetch data')
    }
  },
  async removeEducatorAndStudentFromAppDetails(data) {
    try {
      const response = await api.post('/applications/remove-user-from-application',data)
      return response
    } catch (e) {
      toast.error(e.response.data.message || 'Something went wrong')
    }
  },
}